import React, { useEffect, useMemo } from "react"
import { graphql } from "gatsby"
import { PlpProvider } from '~/contexts/PlpContext'
import PlpInit from '~/initializers/plp-init'

import { Seo } from '~/components/shared/seo'
import Plp from '~/templates/plp'



export default function CollectionTemplate({ data: { collection } }) {
  const { fillCollection } = PlpInit()

  const collData = useMemo(() => {
    return fillCollection(collection)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collection])
  
  return (
    <PlpProvider collData={collection}>
      <Plp />
    </PlpProvider>
  )
}

// <CollectionProvider collData={collection}>
//   <Plp />
// </CollectionProvider>

const collstatus_enum = {
  0: 'live', 
  1: 'marketing_landing', 
  2: 'hidden',  
  4: 'vintage'
}


export const Head = ({ data: { collection } }) => (
  <Seo 
    title={collection.title}
    description={collection.seo_desc ? collection.seo_desc.replaceAll('\n','') : `The Buck Mason ${collection.title} collection`}
    image={collection.img}
    url={`/collections/${collection.handle}`}
    hide={collstatus_enum[collection.status] === 'hidden'}
  />
)


export const pageQuery = graphql`
  query ($handle: String!) {
    collection(handle: { eq: $handle }) {
      handle
      title
      gender
      img
      hero
      status
      description
      seo_desc
      rules
      subnav
      filter_order
      feature_bubb
      all_cats
      product_lines {
        mid
        category
        colors
        filters
        gender
        handle
        is_alt
        name
        pima_id
        short_description
      }
      
      products {
        alt_cuts
        available
        broken
        ncallouts
        filters
        first_full_price
        first_product_price
        handle
        is_alt_cut
        is_vintage
        is_preorder
        low
        media
        mid
        percent_off
        pl_pima
        pub
        shop_id
        short_description
        sku
        tags
        title
        variants

        product_line {
          mid
          pima_id
          gender
        }

        outfits {
          shop_id
          handle
          category
          clr
          image
          title
          first_full_price
          first_product_price
        }
      }
      prods_pk {
        blocks {
          type
          settings
        }
        handle
        media
        mid
        title
        pkstory
        link
      }
      prods_grouped
      prods_coll

      callouts {
        mid
        data
      }
      groups {
        mid
        type
        data
      }
      group_blockers
      ungrouped

      vint {
        available
        first_full_price
        first_product_price
        handle
        media
        mid
        pl_pima
        pub
        shop_id
        sku
        tags
        title
        variants
        is_vintage
        size
        year
        vdescription
        condition
        details
      }
    }
  }
`;



